module.exports = __webpack_public_path__ + "static/media/noun-x-2289990-E91831.1a1318fe.svg";